import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './Sidebar.css';

const Layout = ({ children }) => {
  return (
    <div className="app-shell">
      <Header />
      <div className="app-body">
        <Sidebar />
        <div className="content-area">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
